/** @module SiteAdmin/User/SkinImageRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/Renderer",
	"csi/html"
], function(declare,Renderer,html) {
	const CSS_ATTR = "_CSS";

	return declare(Renderer, {
		/**
		 * @override
		 * Render image using class specified on node.
		 */
		headingToHtml: function(ctx, h, refNode) {
			html.create("div", {"class": "csi-theme-preview-block " + ctx.getNode()[CSS_ATTR]}, refNode);
		}
	});
});
